import { Component, OnInit, EventEmitter, Output,ViewChild,ElementRef,ChangeDetectorRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedserviceService,CommonService } from 'src/app/services';
import { DatePipe, getLocaleTimeFormat } from '@angular/common';
import { ToastrManager } from 'ng6-toastr-notifications';
import {Sort} from '@angular/material/sort';
import jspdf from 'jspdf';
import domtoimage from 'dom-to-image';
import { DOCUMENT } from '@angular/common';
import { DateAdapter } from '@angular/material';
import { NgxUiLoaderService } from 'ngx-ui-loader';
// import { Product } from './product';
declare var $: any;

@Component({
  selector: 'app-bookingfail-list',
  templateUrl: './bookingfail-list.component.html',
  styleUrls: ['./bookingfail-list.component.scss'],
  providers:[DatePipe,NgxUiLoaderService]
})
export class BookingfailListComponent implements OnInit {
  
  searchFlagReset:boolean=false;
  sort_departure_date:any="desc";
  sort_reference_id:any="desc";
  sort_booking_date:any="desc";
  sort_return_flight:any="desc";
  sort_total_book_seats:any="desc";
  sort_total_amount:any="desc";
  checkTraveler : any=[];
  i=1;
  nodatafound:boolean=false;
  cancelticket:any;
  return_d_date:any;
  rreturn_d_date:any;
  delBox:boolean=false;
  sortedBook: any[];
  ccData:any;
  sectordata:any;
  totalpage:any;
  
  profileImg1:any;

  imgPath:any;
  bookData:any;
  userdata:any;
  userlist:any;
  flightData:any;
  returnFlight:any;flt_bokg_dtl:any;

  loadData:any;data:any;keys:any;public page: number = 1;start = 0;msg:any;
  public createForm: FormGroup;
  submitted = false;btnsubmitted:boolean=false;
   editFormFlag:boolean=false;uploadedImagesData: any;
   selectedFile: File=null;status:any;EditFormData:any;FormId:any;
   bodydata:any={};TotalCount:any;PackageStatus:any;
   @ViewChild("fileInput1", {static: false}) fileInput1: ElementRef;files = [];
  @ViewChild("inputSearch", {static: false}) inputSearch: ElementRef;

   myDate = new Date();
   imgProfile:any;
   todate:any="";
   formdate:any="";
   sector:any="";
   type:any="";
   filterstatus:any="";
   headBner: boolean = false;
   imgUrl:any;
  summaryDtl: boolean = false;
  contactDtl: boolean = false;
  booking_id: any;
   
  constructor(
    private ngxLoader: NgxUiLoaderService,
    private dateAdapter: DateAdapter<Date>,
    private datePipe : DatePipe,
    private formBuilder: FormBuilder,
    public sharedService: SharedserviceService,
    public router: Router,
    public commonService:CommonService,
    @Inject(DOCUMENT) private document: Document,
    private toastr: ToastrManager) 
    { 
      this.dateAdapter.setLocale('en-GB');
      this.sortedBook = this.ccData;
      this.userdata=JSON.parse(localStorage.getItem("userAgency_padmawati"));
      this.imgProfile=JSON.parse(localStorage.getItem("imgpathAgency"));
      this.profileImg1 = this.imgProfile
      
    }
    sortData(sort: Sort) {
      const data = this.ccData;
      if (!sort.active || sort.direction === '') {
        this.sortedBook = data;
        return;
      }
      this.sortedBook = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'departure_date': return compare(a.departure_date, b.departure_date, isAsc);
          case 'booking_date': return compare(a.booking_date, b.booking_date, isAsc);
          case 'reference_id': return compare(a.reference_id, b.reference_id, isAsc);
          case 'seller_name': return compare(a.seller_name, b.seller_name, isAsc);
          case 'buyer_name': return compare(a.buyer_name, b.buyer_name, isAsc);
          case 'sector': return compare(a.sector, b.sector, isAsc);
          case 'total_book_seats': return compare(a.total_book_seats, b.total_book_seats, isAsc);
          case 'total_amount': return compare(a.total_amount, b.total_amount, isAsc);
          default: return 0;
        }
      });
      function compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
      }
    }

    applyFilter(event: Event) {
      $("#myInput").on("keyup", function() {
        var value = $(this).val().toLowerCase();
        $("#myTable1 tr").filter(function() {
          $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
        });
      });
    }
    
  ngOnInit() {
    // this.bodydata = 1;
    
    this.bodydata={
      "page_limit": 10,
      "page_no":this.bodydata['page_no'],
      "search": "",
      "flight_type":this.type,
      "sector":this.sector,
      "user_id":"",
      "status": this.filterstatus,
      "start_date": this.formdate,
      "end_date": this.todate,
      "order_key": "departure_date",
      "order_value": "desc",
      "flight_tbl_alias": "FT",
      "flight_booking_tbl_alias": "FB"
    }
    this.bodydata['page_no']=1;
    this.SectorList()
    this.bookinglist(this.bodydata);
    setTimeout(() => {
      this.loadList()  
    }, 100);
    
    this.PackageStatus = '';
  }

  checkCheckBoxvalue(event){
    if(event.checked==true){
        this.headBner=true;
    }else{
        this.headBner=false;
    }
    // 
//console.log(event.checked)
  }

  summaryShow(event) {
    if (event.checked == true) {
      this.summaryDtl = true;
    } else {
      this.summaryDtl = false;
    }
  }
  contactShow(event) {
    if (event.checked == true) {
      this.contactDtl = true;
    } else {
      this.contactDtl = false;
    }
  }
  
  delCheckBox(){
    if(this.delBox==false){
      this.delBox=true;
    }else{
      this.delBox=false;
    }
  }

  fbdCheck(i,event){

    if(event.srcElement.checked == false){
      
//console.log("check false message ");  
      this.checkTraveler.forEach((element,index)=>{
        if(element.id==i) this.checkTraveler.splice(index,1);
      });
    }else{
      
//console.log("check true messgae");  
      this.checkTraveler.push({id:i})
    }
    
  }
 
  get f() { return this.createForm.controls; }

  loadList(){
    this.ngxLoader.start();
    this.sharedService.get('v1/booking/my_booking_count').subscribe((res)=> {
      if(res.replyCode == 'success'){
        this.data = res.data;
        this.ngxLoader.stop();
        
//console.log("booking count  ::: ",this.data)
      }else{
        this.ngxLoader.stop();
        this.toastr.errorToastr(res.replyMsg, 'Error');
      }
    },err=>{
      this.ngxLoader.stop();
      this.toastr.errorToastr(err['error']['replyMsg'], 'Error');
    });
  }
  
  SectorList(){
    this.sharedService.get('v1/booking/my_booking_sector').subscribe((res)=> {
      if(res.replyCode == 'success'){
        this.sectordata = res.data;
        
//console.log("booking sector  ::: ",this.sectordata)
      }else{
        this.toastr.errorToastr(res.replyMsg, 'Error');
      }
    },err=>{
      this.toastr.errorToastr(err['error']['replyMsg'], 'Error');
    });
  }

  bookinglist(bodydata){
    this.ngxLoader.start();
    
    this.sharedService.post('v1/booking/failure_booking_list',bodydata).subscribe((res)=> {
      if(res.replyCode == 'success'){
        // 
//console.log('sunil:::::::',this.ccData)
        this.data = res.data;
        this.ccData=res.data;
        this.keys = Object.keys(this.data[0]);
        this.TotalCount = res.totalRecords
        this.totalpage=res.totalPage
        
//console.log("ccData",this.ccData);
        this.ngxLoader.stop();
      }else{
        this.ngxLoader.stop();
        this.toastr.errorToastr(res.replyMsg, 'Error');
      }
    },err=>{
      this.ngxLoader.stop();
      this.toastr.errorToastr(err.error.replyMsg, 'Error');
    });
  }
 
  sortfun(orderkey,type){
    if(orderkey == 'departure_date' && type == 'desc'){this.sort_departure_date='desc'; }else{this.sort_departure_date='asc';}
    if(orderkey == 'reference_id' && type == 'desc'){this.sort_reference_id='desc'; }else{this.sort_reference_id='asc';}
    if(orderkey == 'booking_date' && type == 'desc'){this.sort_booking_date='desc'; }else{this.sort_booking_date='asc';}
    if(orderkey == 'return_flight' && type == 'desc'){this.sort_return_flight='desc'; }else{this.sort_return_flight='asc';}
    if(orderkey == 'total_book_seats' && type == 'desc'){this.sort_total_book_seats='desc'; }else{this.sort_total_book_seats='asc';}
    if(orderkey == 'total_amount' && type == 'desc'){this.sort_total_amount='desc'; }else{this.sort_total_amount='asc';}
    this.searchFlagReset = true;
    var DataSearch={
      age_limit:10,
      page_no:"",
      search:"",
      status:"",
      flight_type:"",
      sector:"",
      start_date:"",
      end_date:"",
      order_key:orderkey,
      order_value:type,
      flight_tbl_alias:"FT",
      flight_booking_tbl_alias:"FB"
    }
    this.bookinglist(DataSearch);
  }

  onPageChange(event) {
    var data={
      todate:this.todate,
      formdate:this.formdate,
      sector:this.sector,
      type:this.type,
      status:this.filterstatus
    }
    var formdate;
    var todate;
    if(this.formdate !=''){
      formdate = this.datePipe.transform(new Date(this.formdate),'yyyy-MM-dd');
    }else{
      formdate=''
    }
    if(this.todate !=''){
      todate = this.datePipe.transform(new Date(this.todate),'yyyy-MM-dd');
    }else{
      todate=''
    }

    var requestdata={
      page_limit:10,
      page_no:event,
      search:"",
      status:this.filterstatus,
      flight_type:this.type,
      sector:this.sector,
      start_date:formdate,
      end_date:todate,
      order_key:"departure_date",
      order_value:"desc",
      flight_tbl_alias:"FT",
      flight_booking_tbl_alias:"FB"
    }
    this.bodydata['page_no'] = event;
    this.bookinglist(requestdata);
  }

  filtersearch(){
    this.searchFlagReset=true;
    this.ngxLoader.start();
    var data={
      todate:this.todate,
      formdate:this.formdate,
      sector:this.sector,
      type:this.type,
      status:this.filterstatus
    }
    var formdate;
    var todate;
    if(this.formdate !=''){
      formdate = this.datePipe.transform(new Date(this.formdate),'yyyy-MM-dd');
    }else{
      formdate=''
    }
    if(this.todate !=''){
      todate = this.datePipe.transform(new Date(this.todate),'yyyy-MM-dd');
    }else{
      todate=''
    }

    var requestdata={
      page_limit:10,
      page_no:1,
      search:"",
      status:this.filterstatus,
      flight_type:this.type,
      sector:this.sector,
      start_date:formdate,
      end_date:todate,
      order_key:"departure_date",
      order_value:"desc",
      flight_tbl_alias:"FT",
      flight_booking_tbl_alias:"FB"
    }
    this.sharedService.post('v1/booking/failure_booking_list',requestdata).subscribe((res)=> {
      if(res.replyCode == 'success'){
        this.nodatafound=false;
        this.ccData=res.data;
        this.totalpage=res.totalPage
        this.data = res.data;
        this.keys = Object.keys(this.data[0]);
        this.TotalCount = res.totalRecords
        
        this.ngxLoader.stop();
      }else{
        this.ngxLoader.stop();
        this.toastr.errorToastr(res.replyMsg, 'Error');
      }
    },err=>{
      this.ngxLoader.stop();
      this.nodatafound=true;
      this.toastr.errorToastr(err.error.replyMsg, 'Error');
    });
    setTimeout(() => {
      this.loadList();
    }, 100);

  }

  cancel(flight){
    this.cancelticket=flight;
    $('#delete').modal('show'); 
  }
  confirmcancel(flight){
    var requestdata={
      flight_id:flight.flight_id,
      ticket_id:flight.ticket_id,
      ticket_date:flight.booking_date
    }
    this.sharedService.post('v1/flight/cancel_book_ticket', requestdata).subscribe((res) => {
      if (res.replyCode == 'success') {
        this.toastr.successToastr("Ticket Cancelled Successfully","Ticket Cancelled")
        $('#delete').modal('hide');
        $('#genrepo').modal('hide');
        this.bookinglist(this.bodydata);
      }
    });
  }

  durationdiff(dep_time,arr_time,dep_date,type){
    var dep_hr=parseInt(dep_time.split(':')[0]);
    var arr_hr=parseInt(arr_time.split(':')[0]);
    if(arr_hr < dep_hr){
      var nwdate;
      if(!dep_date){
        nwdate =  new Date();
      }else{
       nwdate =  new Date(dep_date);
      }
      
      var newdate= nwdate.setDate(nwdate.getDate()+1);
      if(type == 'oneway'){
        this.return_d_date=this.datePipe.transform(newdate, 'yyyy-MM-dd');
      }else{
        this.rreturn_d_date=this.datePipe.transform(newdate, 'yyyy-MM-dd');
      }
     
    } else{
      this.return_d_date=dep_date;
      this.rreturn_d_date=dep_date;
    } 
    var start_date=dep_date+" "+dep_time;
    var end_date=this.return_d_date+" "+arr_time;  
    return this.getDataDiff(new Date(start_date.toString()), new Date(end_date.toString()));
    
  }

  printpreview(){
    var printW = window.open("");
    var html = document.getElementById('contentToConvert1').innerHTML;

    printW.document.write('<html><head><title>Booking Details</title>');
     printW.document.write(`<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" type="text/css" />`);
     printW.document.write(`<style>
     .col-3 {-webkit-box-flex: 0;flex: 0 0 25%;max-width: 25%;}
     .col-6 {-webkit-box-flex: 0;flex: 0 0 50%;max-width: 50%;}
     table td{border-bottom:1px solid#ddd;padding:5px;border-collapse: collapse;} table th {border-collapse: collapse;padding:5px;font-weight: 600;color: #000;} table{ width: 100%; border-spacing:1px;border-collapse: separate;}.row{display: flex;flex-wrap: wrap;width:100%;}.col-md-6 {-webkit-box-flex: 0;flex: 0 0 50%;max-width: 50%;}.img-box {width: 50px;height: 50px;border: 1px solid #ddd;object-fit:cover;} 
     .border {border: 1px solid #dee2e6!important;}
     table{margin-bottom:5px !important;}
     .ph-text{height:250px !important;font-size:10px !important;line-height:15px !important;}
     .row {display: -webkit-box;display: flex;flex-wrap: wrap;}
     .text-left {text-align: left!important;}
     .img-profile {height: auto;-o-object-fit: contain;object-fit: contain;max-height: 60px;float:left;}
      .text-center {text-align: center!important;}
      .col-6 {-webkit-box-flex: 0;flex: 0 0 50%;max-width: 50%;}
      .head-clr {color: #ff6a00;}.fw-500 {font-weight: 500;}
      .m-0 {margin: 0!important;}.w-100 {width: 100%!important;}.text-center {text-align: center!important;}
      .bg-white {background-color: #fff!important;}
      table {border-collapse: collapse;}
      .table {width: 100%;color: #212529;}
      .col-lg-4 {-webkit-box-flex: 0;flex: 0 0 33.333333%;max-width: 33.333333%;}
      .wp-100{width:100%;} .wp-30{width:30% !important;}
      .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
        margin-bottom:.5rem !important;font-weight: 500;line-height: 1.2;}
      .mytbl td {padding: 0.5rem;margin-bottom: 0rem !important;}
      .mytbl td {padding: 0.5rem !important;vertical-align: middle;padding-left: 0.75rem !important;}
      .table td, .table th {padding: .75rem;vertical-align: top;border-top: 1px solid #dee2e6;}
      .border-bottom {border-bottom: 1px solid #dee2e6!important;}
      .img-box-fix {width: 50px;height: 30px;-o-object-fit: contain;object-fit: contain;}
      img {vertical-align: middle;border-style: none;}
      .textclr {color: #828282;}
      .ft-12 {font-size: 12px !important;}
      .align-self-center {align-self: center!important;}
      .table-responsive {display: block;width: 100%;overflow-x: auto;-webkit-overflow-scrolling: touch;}
      .d-none {display: none!important;}.text-dark {color: #343a40!important;}.h6, h6 {font-size: 1rem;}
      .form-control:disabled, .form-control[readonly] {background-color: #e9ecef !important;opacity: 1;}
      .form-control {display: block;width: 100%;height: calc(1.5em + .75rem + 2px);padding: .375rem .75rem;font-size: 1rem;
        font-weight: 400;line-height: 1.5;color: #495057;background-color: #fff;background-clip: padding-box;border: 1px solid #ced4da;border-radius: .25rem;-webkit-transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;}
      .prnt-h{line-height:32px !important;}
      .form-control-1{border:1px solid#ddd;border-radius:5px;background-color:#e9ecef;color:#303030;padding:8px;}
      .w-10pr{width:10%;}.w-14pr{width:14%;}.w-25pr{width:25%;}
      .pmt-10{margin-top:10px;}.p-Size{font-size:12px;}.pmb-1{margin-bottom:10px !important;}.pmb-2{margin-bottom:15px !important; }
      .mytbl tr td{padding:2px;}.pmt-1{margin-bottom:10px !important;}.pmt-2{margin-bottom:15px !important; }
      </style>`);
    printW.document.write('</head><body >');
    printW.document.write(html);
    printW.document.write('</body></html>');



   // var html = document.getElementById('contentToConvert1').innerHTML;
    // printW.document.write(html);
    printW.document.close();
    printW.focus();
    printW.print();
    // if(this.commonService.osname != "Mac OS"){
  //   printW.close();
  // }else{
  //   console.log("not Windows os")
  // }
  }
  getDataDiff(s_date, e_date){
    var diff = e_date.getTime() - s_date.getTime();
    var days = Math.floor(diff / (60 * 60 * 24 * 1000));
    var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
    var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
    var seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));
    return hours+" hrs "+": "+minutes+" min";
    // return { day: days, hour: hours, minute: minutes, second: seconds };
  }

//   viewDetail(element){
    
// //console.log("element data :::: ",element)
//     var self = this;
//     var Objects = {
//       user_id:this.userdata.id,
//       flight_booking_id:element.flight_booking_id
//     }
//     // 
// //console.log("object::::",Objects);    
//     this.sharedService.post('v1/flight/flight_booking_details', Objects).subscribe((res) => {
//       if (res.replyCode == 'success') {
        
//         setTimeout(() => {
//           this.imgPath = res.imgBasePath;
//           this.bookData = res.data;
//           this.bookData.ticket_id=element.flight_booking_id;
//           this.flightData = res.data;
//           self.returnFlight = res.data.flightData.return_flight ;
//           self.flt_bokg_dtl = res.data.flight_booking_details;
//           var selectedText = this.bookData.departure_date;
//           var selectedDate = new Date(selectedText);
//           var now = new Date();
//           var newdate= now.setDate(now.getDate()-1);
//           if (selectedDate < new Date(newdate)) {
//             this.bookData.nooption=1;
//           }else{
//             this.bookData.nooption=0;
//           }

//         }, 100);
       
//       }       
//     });
//     $('#genrepo').modal('show');
//   }

  onSearch(){
    this.searchFlagReset = true;
    var requestdata={
      page_limit:10,
      page_no:"",
      search:String(this.inputSearch.nativeElement.value),
      status:"",
      flight_type:"",
      sector:"",
      start_date:"",
      end_date:"",
      order_key:"departure_date",
      order_value:"desc",
      flight_tbl_alias:"FT",
      flight_booking_tbl_alias:"FB"
    }
    this.bookinglist(requestdata);
}

  onReset(){
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  viewDetail(element){
    this.booking_id = element.flight_booking_id
    console.log("booking id check:::::::::::",this.booking_id);
    sessionStorage.setItem("booking_id", JSON.stringify(this.booking_id));
    // this.router.navigate(['/book-summery/']);
    this.router.navigate([]).then(result => { window.open('/book-summery/', '_blank'); });
  }

}





